import { render } from "./GroupModal.vue?vue&type=template&id=8c9a304a&scoped=true"
import script from "./GroupModal.vue?vue&type=script&lang=js"
export * from "./GroupModal.vue?vue&type=script&lang=js"

import "./GroupModal.vue?vue&type=style&index=0&id=8c9a304a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c9a304a"]])

export default __exports__